"use-strict";

import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"; // <-- import styles to be used
import { Link } from "react-router-dom";

export default class Review extends Component {

  render() {
    return (
      <div className="bounds">
        <div
          className="grid-100 rDiv"
        >
          <span
            style={{
              backgroundColor: "#3D3D3D",
              position: "absolute",
              width: "100%",
              height: "100%",
              left: "0%",
              zIndex: -1,
              top: "90px",
              opacity: "75%",
            }}
          ></span>
          <img
            src={'https://media3.giphy.com/media/r0LaehSESRcu6KWcjX/giphy.gif?cid=790b76116425057565f8187aa96abeccd0b0266838e91d25&rid=giphy.gif&ct=g'}
            alt="hope"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              left: "0%",
              zIndex: -2,
              top: "90px",
            }}
          ></img>

          <div className="contss" >
            <div style={{ display: "block" }}>
              <Link id="top" to="/reviews/toprated" style={styles.link}>
                <FontAwesomeIcon
                  className="text-warning iconImg"
                  icon={solid("people-group")}
                  style={styles.link}
                />
              </Link>
              <label
                htmlFor="top"
                className="text-warning"
                style={{
                  marginTop: "5%",
                  fontFamily: '"Play", sans-serif',
                  fontSize: "45px",
                }}
              >
                Top-Rated
              </label>
            </div>
            <div style={{ display: "block" }}>
              <Link id="reviewcom" to="/reviews/reviewcom" style={styles.link}>
                <FontAwesomeIcon
                  className="text-warning iconImg"
                  icon={solid("comment-dots")}
                  style={styles.link}
                />
              </Link>
              <label
                htmlFor="reviewcom"
                className="text-warning"
                style={{
                  marginTop: "5%",
                  fontFamily: '"Play", sans-serif',
                  fontSize: "45px",
                }}
              >
                Make A Review
              </label>
            </div>
            {/* <div style={{ display: "block" }}>
              <Link id="find" to="/reviews/find" style={styles.link}>
                <FontAwesomeIcon
                  className="text-warning iconImg"
                  icon={solid("magnifying-glass-arrow-right")}
                  style={styles.link}
                />
              </Link>
              <label
                htmlFor="find"
                className="text-warning"
                style={{
                  marginTop: "5%",
                  fontFamily: '"Play", sans-serif',
                  fontSize: "45px",
                }}
              >
                Find Reviews
              </label>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}
const styles = {
  cont: {
    display: "inline-flex",
    width: "100%",
    height: "100%",
  },
  link: {
    cursor: "pointer",
    width: "70%",
    height: "70%",
  },
  bot: {
    cursor: "pointer",
    width: "50%",
    height: "70%",
  },
};
